{
  "selectAsField": "「{value}」を{fieldName}として選択",
  "typeToSearchField": "入力して{fieldName}を検索",
  "licenseFieldLabel": "ナンバープレートを選択（例：215BG2）",
  "licenseFieldName": "ナンバープレート",
  "licensePlaceholder": "ナンバープレートで検索",
  "dotFieldLabel": "DOT 番号を選択",
  "dotFieldName": "DOT 番号",
  "dotPlaceholder": "DOT 番号で検索"
}
